module.exports = __webpack_public_path__ + "img/shape_right_triangle.3c212fc3.svg";